/* baitishk-collection.js
   Collection page: Type filter bar (filter pills + scroll arrows).
   Delegates filter changes to the theme's FacetFiltersForm system.

   Note: Product prev/next sticky nav bar removed in Phase 5.6 per
   user request -- the breadcrumb already covers navigation.
*/
(function () {
  'use strict';

  var FILTER_NAME = 'filter.p.product_type';

  /* ================================================================
     FIND THE THEME FILTER FORM
     ================================================================ */
  function getFilterForm() {
    return document.getElementById('FacetFiltersForm')
        || document.getElementById('FacetFiltersFormDrawer');
  }

  /* ================================================================
     TRIGGER THEME FILTER
     Mirrors clicking a Type checkbox inside the filter drawer:
       1. Uncheck all type checkboxes
       2. Check the target one (unless "All")
       3. Dispatch `input` on the form -- FacetFiltersForm handles the rest
     ================================================================ */
  function triggerThemeFilter(typeValue) {
    var form = getFilterForm();
    if (!form) {
      console.warn('[Baitishk] Filter form not found.');
      return;
    }

    var allTypeInputs = form.querySelectorAll('input[name="' + FILTER_NAME + '"]');
    allTypeInputs.forEach(function (cb) { cb.checked = false; });

    if (typeValue && typeValue !== '__all__') {
      var target = form.querySelector('input[name="' + FILTER_NAME + '"][value="' + typeValue + '"]');
      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
    }

    var anyInput = allTypeInputs[0] || form.querySelector('input, select');
    if (anyInput) {
      anyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  /* ================================================================
     SCROLL TO RESULTS AFTER FILTER RE-RENDER
     The theme's FacetFiltersForm scrolls at fetch-start (before the
     new grid HTML arrives). Filtering from low on a long page then
     collapses the grid to a shorter result, and the browser cancels
     that in-flight smooth scroll -- stranding you near the
     recommendations. Fix: wait until the grid innerHTML is actually
     swapped (#CollectionGird), THEN scroll. Height is final by then,
     so nothing cancels it. Offset by the sticky stack (header + type
     bar + filter toolbar) so the first row sits just below the bars.
     ================================================================ */
  function btkStickyOffset() {
    var hv = getComputedStyle(document.documentElement)
               .getPropertyValue('--header-height').trim();
    var headerPx = hv.indexOf('rem') > -1 ? parseFloat(hv) * 10
                 : hv.indexOf('px')  > -1 ? parseFloat(hv)
                 : (parseFloat(hv) || 60);
    var typeBar = document.querySelector('.baitishk-type-bar-section');
    var toolbar = document.querySelector('.facets-toolbar');
    return headerPx
         + (typeBar ? typeBar.offsetHeight : 0)
         + (toolbar ? toolbar.offsetHeight : 0)
         + 8;
  }

  function btkScrollToResultsTop() {
    var grid = document.getElementById('product-grid')
            || document.getElementById('CollectionGird')
            || document.getElementById('ProductsGridContainer');
    if (!grid) return;
    var target = grid.getBoundingClientRect().top + window.scrollY - btkStickyOffset();
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  }

  var btkFilterObs = null;
  function btkScrollAfterFilterRender() {
    var gird = document.getElementById('CollectionGird');
    if (!gird) { setTimeout(btkScrollToResultsTop, 600); return; }
    if (btkFilterObs) { btkFilterObs.disconnect(); btkFilterObs = null; }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (btkFilterObs) { btkFilterObs.disconnect(); btkFilterObs = null; }
      requestAnimationFrame(function () {
        requestAnimationFrame(btkScrollToResultsTop);
      });
    }
    btkFilterObs = new MutationObserver(finish);
    btkFilterObs.observe(gird, { childList: true });
    /* Safety net in case the swap does not fire a childList mutation. */
    setTimeout(finish, 3000);
  }

  /* ================================================================
     TYPE BAR -- SCROLL ARROWS
     ================================================================ */
  function initTypeBarArrows() {
    var bar    = document.getElementById('baitishk-type-bar');
    var scroll = document.getElementById('baitishk-type-scroll');
    if (!bar || !scroll) return;

    var prev = bar.querySelector('.baitishk-type-arrow--prev');
    var next = bar.querySelector('.baitishk-type-arrow--next');

    function updateArrows() {
      if (prev) prev.disabled = scroll.scrollLeft <= 2;
      if (next) next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
    }

    if (prev) prev.addEventListener('click', function () { scroll.scrollBy({ left: -240, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroll.scrollBy({ left:  240, behavior: 'smooth' }); });
    scroll.addEventListener('scroll', updateArrows, { passive: true });

    var active = scroll.querySelector('.baitishk-type-pill.is-active');
    if (active) scroll.scrollLeft = active.offsetLeft - scroll.clientWidth / 2 + active.clientWidth / 2;

    updateArrows();
  }

  /* ================================================================
     TYPE BAR -- CLICK HANDLER
     ================================================================ */
  function initTypeBar() {
    var bar = document.getElementById('baitishk-type-bar');
    if (!bar) return;

    bar.addEventListener('click', function (e) {
      var pill = e.target.closest('.baitishk-type-pill');
      if (!pill) return;
      e.preventDefault();
      if (pill.classList.contains('is-active')) return;

      bar.querySelectorAll('.baitishk-type-pill').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-selected', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-selected', 'true');

      triggerThemeFilter(pill.dataset.baitishkType);
      btkScrollAfterFilterRender();
    });

    window.addEventListener('popstate', function () {
      syncPillsFromUrl();
    });
  }

  /* Keep pill active state in sync if user also uses the drawer filter */
  function syncPillsFromUrl() {
    var bar = document.getElementById('baitishk-type-bar');
    if (!bar) return;

    var params = new URLSearchParams(window.location.search);
    var activeType = params.get(FILTER_NAME);

    bar.querySelectorAll('.baitishk-type-pill').forEach(function (p) {
      var isAll    = p.dataset.baitishkType === '__all__';
      var isActive = activeType ? p.dataset.baitishkType === activeType : isAll;
      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-selected', String(isActive));
    });
  }

  /* ================================================================
     INIT
     ================================================================ */
  function init() {
    syncPillsFromUrl();
    initTypeBar();
    initTypeBarArrows();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

}());

  /* -----------------------------------------------------------
   * PATCH 9: Drive the slim top loading bar on navigation (iOS-safe)
   * The branded splash is disabled, so the theme renders
   * <progress-bar-load> and it is styled in baitishk-section25.css (S34).
   * The theme only fires the bar's fill on 'beforeunload', which iOS
   * Safari (our primary device, ~92% of traffic) does not reliably
   * dispatch -- so on iPhone the bar would essentially never appear.
   * Trigger it on real same-origin link navigations (the moment of
   * intent, which is also when a YouTube-style bar should start) and on
   * pagehide. Visual only: we NEVER call preventDefault and never block,
   * delay, or alter the navigation. If a click does not actually navigate
   * (e.g. an AJAX collection-filter link) a safety timer resets the bar
   * so it can never stick at 100%. On bfcache restore (pageshow) we clear
   * it. No-ops cleanly when the element is absent (branded splash re-on).
   * ----------------------------------------------------------- ------ */
  (function () {
    function barEl() { return document.querySelector('progress-bar-load'); }

    function fillBar() {
      var el = barEl();
      if (!el || typeof el.complete !== 'function') return;
      try { el.complete(); } catch (e) { return; }
      clearTimeout(el.__btkResetT);
      el.__btkResetT = setTimeout(function () {
        var bar = el.querySelector('.indeterminate');
        if (bar) { bar.style.transition = 'width 200ms ease'; bar.style.width = '0%'; }
      }, 2000);
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|sms:|javascript:|whatsapp:|intent:)/i.test(href)) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname &&
          url.search === window.location.search && url.hash) return;
      fillBar();
    }, true);

    window.addEventListener('pagehide', fillBar);
    window.addEventListener('pageshow', function () {
      var el = barEl();
      if (!el) return;
      clearTimeout(el.__btkResetT);
      var bar = el.querySelector('.indeterminate');
      if (bar) { bar.style.transition = 'none'; bar.style.width = '0%'; }
    });
  })();
